import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { pca } from './Utils/MsalConfig';
import { AuthProvider } from './Utils/AuthContext';
import { ToastProvider } from './Components/Toast';
import { CompanyProvider } from './Utils/CompanyContext';

// pca is configured in ./Utils/MsalConfig.ts

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CompanyProvider>
        <MsalProvider instance={pca}>
          <AuthProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </AuthProvider>
        </MsalProvider>
      </CompanyProvider>
    </BrowserRouter>
  </React.StrictMode>
);